import React from 'react'

import { useMutation } from '@apollo/client'
import defaultTo from 'lodash/defaultTo'
import filter from 'lodash/filter'
import flow from 'lodash/flow'
import noop from 'lodash/noop'
import Router from 'next/router'

import MUTATION from './remove-user-element-page-profile.graphql'

const RemoveElementPageProfile = ({
  children,
  elementId,
  elementTypename,
  type,
  callback,
  value,
  ...props
}) => {
  const [mutate] = useMutation(MUTATION, {
    refetchQueries: ['UserProfilePageElementsByType'],
  })

  const flowOnClick = flow([
    () =>
      mutate({
        variables: {
          elements: [{ id: elementId, type, value }],
        },
      }),
    defaultTo(callback, noop) as any,
  ])

  return (
    <button {...props} onClick={flowOnClick}>
      {children}
    </button>
  )
}

export default RemoveElementPageProfile
